import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { Linkedin, Twitter, Mail } from "lucide-react";
import { team, images, company } from "@/mock/mock";

function initials(name) {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("");
}

export default function Team() {
  return (
    <>
      <PageHeader
        eyebrow="Team"
        title="Meet the specialists behind your security"
        subtitle="A multidisciplinary team of SOC analysts, forensic examiners and governance experts protecting Canadian organizations every day."
      />

      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {team.map((m, i) => (
            <Reveal key={m.name} delay={(i % 4) * 70}>
              <div className="group h-full rounded-2xl border border-white/10 bg-brand-navy2/60 p-7 text-center card-hover">
                <div className="mx-auto grid h-24 w-24 place-items-center rounded-full bg-gradient-to-br from-brand-lime/20 to-brand-cyan/20 border border-white/10">
                  <span className="font-display text-2xl font-bold text-brand-lime">{initials(m.name)}</span>
                </div>
                <h3 className="mt-5 font-display text-lg font-semibold text-white">{m.name}</h3>
                <p className="text-sm text-brand-lime">{m.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{m.bio}</p>
                <div className="mt-5 flex items-center justify-center gap-3">
                  <a href={m.linkedin || "#"} target={m.linkedin && m.linkedin !== "#" ? "_blank" : undefined} rel="noopener noreferrer" aria-label="LinkedIn" className="h-8 w-8 grid place-items-center rounded-full bg-white/5 text-slate-400 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Linkedin className="h-4 w-4" /></a>
                  <a href="#" aria-label="Twitter" className="h-8 w-8 grid place-items-center rounded-full bg-white/5 text-slate-400 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Twitter className="h-4 w-4" /></a>
                  <a href={`mailto:${company.email}`} aria-label="Email" className="h-8 w-8 grid place-items-center rounded-full bg-white/5 text-slate-400 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Mail className="h-4 w-4" /></a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20 border-t border-white/10 bg-brand-navy2/40">
        <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="rounded-2xl overflow-hidden border border-white/10">
              <img src={images.businessTeam} alt="Our team" className="w-full h-[360px] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">Careers</span>
            <h2 className="mt-3 font-display text-3xl font-bold text-white">Grow your career defending Canadian business</h2>
            <p className="mt-4 text-slate-400">We're always looking for talented analysts, engineers and consultants who care about doing security the right way. If that's you, we'd love to hear from you.</p>
            <a href={`mailto:${company.email}`} className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-orange hover:bg-brand-orangeDark px-7 h-12 font-semibold text-white transition-colors">
              <Mail className="h-5 w-5" /> Send us your resume
            </a>
          </Reveal>
        </div>
      </section>
    </>
  );
}
